import React from 'react';
import { Link } from 'react-router';

function EurydiceTestbedsHome() {
    return (
        <div>
            <h1>Eurydice: Component Testbed's home</h1>
            <ul>
                <li><Link to="/">Dev Home</Link></li>
            </ul>

            m7
            <ul>
                <li><Link to="/testbeds/testbeds/MixerPanelTestbed">MixerPanel</Link></li>
            </ul>

            Widgets:
            <ul>
                <li><Link to="/testbeds/widgets/spinner">Loading Spinner</Link></li>
                <li><Link to="/testbeds/testbeds/ColorTableTestbed">ColorTable</Link></li>
                <li><Link to="/testbeds/widgets/fretboard">Fretboard</Link></li>
                <li><Link to="/testbeds/widgets/chord-selector">Chord selector</Link></li>
                <li><Link to="/testbeds/widgets/scale-selector">Scale builder</Link></li>
                <li><Link to="/testbeds/widgets/selected-notes-infobox">Selected notes infobox</Link></li>
                <li><Link to="/testbeds/testbeds/MiniWindowTestbed">MiniWindow</Link></li>
                <li><Link to="/testbeds/testbeds/RydNumericInputTestbed">Numeric input testbeds</Link></li>
            </ul>

            Components:
            <ul>
                <li><Link to="/components/all">All</Link></li>
                <li><Link to="/components/piano-roll-viewport">PianoRoll viewport</Link></li>
                <li><Link to="/components/piano-roll-operations-container">PianoRollOperationContainer</Link></li>
                <li><Link to="/components/chord-recognizer">Chord Recognizer</Link></li>
                <li><Link to="/components/duration-selector">Duration selector</Link></li>
                <li><Link to="/components/midi-controls">Midi Controls</Link></li>
                <li><Link to="/components/tonality-selector">Tonality Selector</Link></li>
                <li><Link to="/components/highlight-colors">Pianoroll highlight colors</Link></li>
                <li><Link to="/testbeds/testbeds/MidiLoaderTestbed">MidiLoader</Link></li>
                <li><Link to="/testbeds/testbeds/NoteRangeSelectorTestbed">NoteRangeSelector</Link></li>
                <li><Link to="/testbeds/testbeds/GridResolutionDialogTestbed">GridResolutionDialog</Link></li>
                <li><Link to="/testbeds/testbeds/PlaybackCaretIndicatorDialogTestbed">PlaybackCaretIndicatorDialog</Link></li>
            </ul>
            Testbeds:
            <ul>
                <li><Link to="/testbeds/playback">Playback</Link></li>
                <li><Link to="/testbeds/song-structure">Song structure</Link></li>
                <li><Link to="/testbeds/capture-tuner">Audio Capture (tuner)</Link></li>
                <li><Link to="/testbeds/testbeds/ScaleIdentifyierTestbed">ScaleIdentifyier</Link></li>
                <li><Link to="/testbeds/testbeds/MetronomePatternTestbed">MetronomePattern</Link></li>
            </ul>
            Context:
            <ul>
                <li><Link to="/components/context-time-signature">Time signature/Metronome</Link></li>
                <li><Link to="/components/context-plane">Context Plane</Link></li>
            </ul>
            Instruments:
            <ul>
                <li><Link to="/testbeds/virtual-instruments">Virtual instruments (tonejs)</Link></li>
                <Link to="/testbeds/testbeds/InstrumentSelectionDialogTestbed">InstrumentSelectionDialog</Link>
                {/* <li><Link to="/testbeds/instruments/guitar">Guitar</Link></li>
                <li><Link to="/testbeds/instruments/bass">Bass</Link></li> */}
            </ul>
            Audio:
            <ul>
                <li><Link to="/testbeds/testbeds/RydSpectrogramTestbed">Spectrogram</Link></li>
                <li><Link to="/testbeds/testbeds/AudioInputSelectorTestbed">AudioInputSelector</Link></li>
            </ul>
            Panels:
            <ul>
                <li><Link to="/testbeds/testbeds/UserAccountPanelTestbed">UserAccountPanel</Link></li>
                <li><Link to="/testbeds/testbeds/SampleNavigatorTestbed">SampleNavigator</Link></li>
            </ul>

            Pianorolls:
            <ul>
                <li><Link to="/testbeds/testbeds/ProjectMainOptionsTestbed">ProjectMainOptions</Link></li>
                <li><Link to="/components/piano-roll-keybed">PianoRollKeybed</Link></li>
                <li><Link to="/testbeds/testbeds/PianoRollTestbed">PianoRoll</Link></li>
                <li><Link to="/components/chord-roll">ChordRoll</Link></li>
                <li><Link to="/testbeds/testbeds/PianoRollBackgroundTestbed">PianoRollBackground</Link></li>
                <li><Link to="/components/collapsed-rolls">Collapsed rolls</Link></li>
            </ul>
        </div>
    );
}
export default EurydiceTestbedsHome;